import React, { useState } from "react";

import Input from "../../../components/FormComponents/Input";
import { useAxiosContext } from "../../../context/AxiosContext";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import Button from "../../../components/FormComponents/Button";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const UserForm = ({
  isEdit,
  selectedConnectorId,
  setIsOpenCallback,
  users,
  selectedUser,
  setUsersCallback,
  edit = false
}) => {
  const [userData, setUserData] = useState(
    selectedUser || {
      name: "",
      description: "",
      username: "",
      default: false,
      ssl: false,
      access_level: "1"
    }
  );
  const [error, setError] = useState("");
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();

  // This function now checks if the parameter is an event with a target or a direct value (from SingleSelectBox)
  const handleChange = (e, field) => {
    if (field === "access_level") {
      // Handle case when SingleSelectBox provides a value
      setUserData((prev) => ({
        ...prev,
        access_level: e.id
      }));
    } else if (e && e.target && e.target.name) {
      // Handle case for other input fields
      const { name, type, checked, value } = e.target;
      setUserData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    }
  };

  const handleAdd = async () => {
    if (!userData.name || !userData.username || !userData.password) {
      setError("All Fields are required");
      return;
    }

    try {
      const response = await axiosInstance.post(`/dbuser/connector/${selectedConnectorId}`, { users: [userData] });

      handleSuccess(response.message);
      setUsersCallback([...users, userData]);
      setIsOpenCallback(false);
    } catch (error) {
      handleError(error);
    }
  };
  console.log("userData", userData);

  const handleSave = async () => {
    try {
      const response = await axiosInstance.patch(
        `/dbuser/${userData.user_id}/connector/${selectedConnectorId}`,
        userData
      );

      handleSuccess(response.message);
      setIsOpenCallback(false);
      const newUsers = users.map((user) =>
        user.user_id === selectedUser.user_id ? { ...response.data } : { ...user, default: false }
      );
      setUsersCallback(newUsers);
    } catch (error) {
      handleError(error);
    }
  };
  return (
    <div>
      <Input name="name" containerClassName="mb_3" value={userData.name} label="Name" onChange={handleChange} />
      <Input
        name="description"
        containerClassName="mb_3"
        value={userData.description}
        label="Description"
        onChange={handleChange}
      />
      <Input
        name="username"
        containerClassName="mb_3"
        value={userData.username}
        label="Username"
        onChange={handleChange}
      />

      {isEdit ? (
        <Input
          name="password"
          containerClassName="mb_3"
          value={isEnvValue(userData.password) ? userData.password : "********"}
          label="Password"
          onChange={handleChange}
          disabled
        />
      ) : (
        <Input
          name="password"
          containerClassName="mb_3"
          value={userData.password}
          label="Password"
          onChange={handleChange}
        />
      )}

      <SingleSelectBox
        label="Access Level"
        onChange={(selected) => handleChange(selected, "access_level")}
        options={[
          { id: "1", name: "1" },
          { id: "2", name: "2" },
          { id: "3", name: "3" },
          { id: "4", name: "4" },
          { id: "5", name: "5" }
        ]}
        selectedData={userData.access_level + ""}
        className="dbuser-placeholder"
      />

      <div className="d_flex gap_3">
        <Input
          name="default"
          containerClassName="mb_3"
          label="Default User"
          type="checkbox"
          onChange={handleChange}
          checked={userData.default}
        />
        <Input
          name="ssl"
          containerClassName="mb_3"
          label="SSL"
          type="checkbox"
          onChange={handleChange}
          checked={userData.ssl}
        />
      </div>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {edit ? <Button onClick={handleSave}>Save</Button> : <Button onClick={handleAdd}>Add</Button>}
    </div>
  );
};

const isEnvValue = (value = "") => {
  const v = value.trim();
  return v.startsWith("{{env.") && v.endsWith("}}");
};

export default UserForm;
